import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-7-small', 'Number7Small', [["path",{"d":"M10 8h4l-2 8","key":"svg-0"}]]);